import { useMutation } from "@apollo/client"
import { FORMAT_UPDATE } from "../queries/adminQueries"

export interface FormatUpdateInput {
  id: number
  name: string
  description?: string
  status: boolean
  sortOrder?: number
  gameIds?: number[]
}

export const useFormatUpdate = () => {
  const [updateFormat, { loading, error }] = useMutation(FORMAT_UPDATE)

  const handleUpdateFormat = async (input: FormatUpdateInput) => {
    try {
      const { data } = await updateFormat({
        variables: { FormatUpdateInput: input },
      })
      return data?.FormatUpdate
    } catch (err) {
      throw err
    }
  }

  return {
    updateFormat: handleUpdateFormat,
    loading,
    error,
  }
}
